import React, { useEffect, useState } from 'react';
import _ from 'lodash';

import useMediaQuery from '@mui/material/useMediaQuery';
import Stack from "@mui/material/Stack";

import ProductSelection from './ProductSelection';
import ProductInfo from './ProductInfo';
import CustomProductTitle from './CustomProductTitle';
import ObjectiveType from './ObjectiveType';

import { PROTUCT_TYPE } from '../constants';
import { ContentOutBox, ContentInBox } from './generationFormStyle';

import theme from '../../../theme';

const GenerationForm = (props) => {
  const {
    productType,
    setProductType,
    generationForm,
    setGenerationForm,
    inputErrorMsg,
    progress,
    setIsLoading
  } = props;

  const isMoblie = useMediaQuery(theme.breakpoints.down('md'));

  const handleInput = (e) => {
    const { name, value } = e.target;
    setGenerationForm(prev => {
      _.set(prev, name, value);
      return { ...prev };
    });
  }

  return (
    <>
      <ContentOutBox ismoblie={isMoblie.toString()} width={isMoblie ? '100%' : '40%'}>
        <ContentInBox>
          <Stack variant='between-start'>
            <ProductSelection
              productType={productType}
              setProductType={setProductType}
              generationForm={generationForm}
              inputErrorMsg={inputErrorMsg}
              progress={progress}
            />
          </Stack>
          {productType === PROTUCT_TYPE.SELECT && generationForm?.product_title &&
            <ProductInfo generationForm={generationForm} />
          }
          {productType === PROTUCT_TYPE.CUSTOM &&
            <CustomProductTitle
              generationForm={generationForm}
              inputErrorMsg={inputErrorMsg}
              handleInput={handleInput}
            />
          }
          <ObjectiveType
            generationForm={generationForm}
            inputErrorMsg={inputErrorMsg}
            handleInput={handleInput}
          />
        </ContentInBox>
      </ContentOutBox>
    </>
  )
}

export default GenerationForm;


